import useLanguage from "hooks/language";
import legacyStyles from "../../pages/home/screening/public-upfront-payments/upfront-payments.module.css";
import bookingFlowStyles from "./booking-flow-payment.module.css";

export type BookingFlowPaymentFooterDisclaimersProps = {
    variant?: "bookingFlow" | "legacy" | "hpvLegacy";
    cancellationText?: string;
    showDelayWarning?: boolean;
    delayText?: string;
};

export default function BookingFlowPaymentFooterDisclaimers({
    variant = "bookingFlow",
    cancellationText,
    showDelayWarning = true,
    delayText,
}: BookingFlowPaymentFooterDisclaimersProps): JSX.Element {
    const { translations } = useLanguage();
    const t = translations.upfrontPaymentSection;
    const defaultCancellation = t.cancellationOrReschedulingFeeWarning;
    const delay = delayText ?? t.delayWarning;
    const cancellation =
        cancellationText !== undefined
            ? cancellationText
            : variant === "bookingFlow"
            ? undefined
            : defaultCancellation;
    if (variant === "hpvLegacy") {
        return cancellation ? (
            <p className="hpv-upfront-payments__warning">{cancellation}</p>
        ) : (
            <></>
        );
    }

    if (variant === "legacy") {
        return (
            <>
                {cancellation && (
                    <p className={legacyStyles.upfrontPaymentsSection__text}>
                        {cancellation}
                    </p>
                )}
                {showDelayWarning && (
                    <p
                        className={`${legacyStyles.upfrontPaymentsSection__text} ${legacyStyles["upfrontPaymentsSection__text--footer"]}`}
                    >
                        {delay}
                    </p>
                )}
            </>
        );
    }

    return (
        <>
            {cancellation && (
                <p className={bookingFlowStyles.cancellation}>{cancellation}</p>
            )}
            {showDelayWarning && (
                <p className={bookingFlowStyles.delay}>{delay}</p>
            )}
        </>
    );
}
